import { asyncTryAndReturn } from '../../common/catcher'
import { performanceAsyncWrapper } from '../../common/performance-decorator'
import {
  getPbxId,
  setContextLocalStoragePbxInfo,
  setContextLocalStorageAccountKey,
  getPbxUserId,
} from '../../services/context'
import type { ContextApi } from '../../services/context/models'
import { AccountContext, PbxContext } from '../../services/context/models'
import { getAccountKey } from '../../services/identity'
import { getProductTrialInfo } from '../../services/product'

export const setupContextApi = async (
  email: string | undefined,
  externalUserKey: string | undefined,
): Promise<ContextApi> =>
  await performanceAsyncWrapper('contextApiSetup', async () => {
    let context: ContextApi = {}
    const pbxId = await Promise.resolve(
      email && externalUserKey
        ? asyncTryAndReturn({ func: () => getPbxId(email, externalUserKey) })
        : Promise.resolve(undefined),
    )
    const pbxUserId = await Promise.resolve(
      email && pbxId ? asyncTryAndReturn({ func: () => getPbxUserId(email, pbxId) }) : Promise.resolve(undefined),
    )
    const accountKey = await Promise.resolve(
      externalUserKey
        ? asyncTryAndReturn({ func: () => getAccountKey(externalUserKey, pbxId) })
        : Promise.resolve(undefined),
    )
    const productTrial = await Promise.resolve(
      externalUserKey ? asyncTryAndReturn({ func: () => getProductTrialInfo() }) : Promise.resolve(undefined),
    )
    if (externalUserKey && pbxId) {
      setContextLocalStoragePbxInfo({ externalUserKey, pbxId, pbxUserId })
    }
    if (externalUserKey && accountKey) {
      setContextLocalStorageAccountKey(externalUserKey, accountKey)
    }
    context = { account: new AccountContext(accountKey), pbx: new PbxContext(pbxId, pbxUserId), productTrial }
    return context
  })()
